import * as React from 'react';
import { IDataEntity, IColumnMap, IGroupedRow, IAppParams, IWatchlist } from '../../models';
import { safe, getValueFromStringNotation, getDisplayValue, toCode, getShareDocumentByType } from "../../utils";
import { CardRow } from "./";
import { WatchlistButton } from "../WatchlistButton";
import { paramCase } from "change-case";
import { isShareDisabled } from "../../utils";

const styles = require('../FundPages/Fundpages.pcss');
const internalStyles = require('./ExplorerTabContent.pcss');
const FaAngleDown = require('react-icons/lib/fa/angle-down');
const FaAngleUp = require('react-icons/lib/fa/angle-up');

interface IState {
    showCardContent?: boolean;
}

interface IProps {
    toggleShareClass: any;
    rowIndex?: number;
    columns?: IColumnMap[];
    row?: IDataEntity & { key?: string };
    groupedRow?: IGroupedRow;
    watchlist?: IWatchlist[];
    editWatchlist?: any;
    appParams?: IAppParams;
    isPPL?: boolean;
    benchmarks?: IDataEntity[];
    goToFundPage?: any;
}

export class Card extends React.Component<React.Props<{}> & IProps, IState>{
    constructor(props) {
        super(props);
        this.toggleCardContent = this.toggleCardContent.bind(this);
    }

    toggleCardContent() {
        let { row, toggleShareClass } = this.props;
        toggleShareClass(row, !row.collapsed);
    }

    goToFactsheet() {
        let { row, appParams } = this.props;
        let url = getShareDocumentByType(row, appParams, "MR");
        let win = window.open(url, '_blank');
        win.focus();
    }

    render() {
        let { columns, row, groupedRow, rowIndex, watchlist, editWatchlist, appParams, isPPL, goToFundPage } = this.props;

        return (
            <div key={ row.key } className={ internalStyles.card }>
                <div className={ internalStyles.fundName } onClick={ this.toggleCardContent }>
                    <div className={ internalStyles.rightToggleIndicator }>
                        { (() => {
                            if (!row.collapsed) {
                                return (<FaAngleUp></FaAngleUp>);
                            }
                            else {
                                return (<FaAngleDown></FaAngleDown>);
                            }
                        })() }
                    </div>

                    <div>{ groupedRow.fund.properties['fund_name'] }</div>
                    <div>
                        <span className={ internalStyles.leftHeader }>{ row['properties'][isPPL ? 'shareclass_name' : 'shareclass_display'] } - { row['properties']['shareclass_currency_code'] }</span>
                        <span className={ internalStyles.rightHeader }>{ row['properties']['isin'] }</span>
                    </div>
                    <div className={ styles.clearFix }></div>
                </div>
                { (() => {
                    if (!row.collapsed) {
                        return (
                            <div>
                                { columns.filter(column => column.viewRestriction === "card" || (!column.explicitHide && column.viewRestriction !== 'table')).map((column, colIndex) => {
                                    return (
                                        <CardRow key={ `row_${ rowIndex }_col_${ colIndex }` } column={ column } row={ row } groupedRow={ groupedRow } isPPL={ isPPL } appParams={ appParams }></CardRow>
                                    );
                                }) }
                                <div>
                                    <WatchlistButton
                                        appParams={ appParams }
                                        buttonStyle={ styles.fullButton }
                                        isMobile={ true }
                                        isin={ row.clientCode }
                                        fundName={ row.properties.fund_name }
                                        fundIdentifier={ groupedRow.fund.clientCode }
                                        watchlist={ watchlist }
                                        editWatchlist={ editWatchlist } />
                                    { (() => {
                                        if (!isPPL && !isShareDisabled(row.clientCode)) {
                                            return (
                                                <button
                                                    type="button"
                                                    onClick={ event => goToFundPage(row, event) }
                                                    className={ styles.fullButton }>
                                                    View Fund Page
                                                </button>
                                            );
                                        }
                                    })() }
                                </div>
                            </div>
                        );
                    }
                })() }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/ExplorerTabContent/Card.tsx